import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  emitGetAnalytics,
  receiveEPulse,
} from "@socket";
import { useMeeting } from "@hooks";

const useSocketConnections = () => {
  const dispatch = useDispatch();
  const [triggerLiveAnaltyics, setTriggerLiveAnaltyics] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const { normalizedMeeting, meetingInstanceId } = useMeeting();
  const profile = useSelector((state) => state.profile.data);

  useEffect(() => {
    let interval;

    if (normalizedMeeting.isActive && profile && meetingInstanceId) {
      emitGetAnalytics({
        userId: profile?._id,
        meetingUuid: meetingInstanceId,
      });

      interval = setInterval(() => {
        emitGetAnalytics({
          userId: profile?._id,
          meetingUuid: meetingInstanceId,
        });
      }, 15000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, normalizedMeeting.isActive, meetingInstanceId, profile]);

  return {
    setTriggerLiveAnaltyics,
    receiveEPulse,
    setIsLive,
  };
};

export default useSocketConnections;
